import React, { useState } from "react";
import AdminCategoriesSelect from "./../helpers/AdminCategoriesSelect";
import AdminPricingsSelect from "./../helpers/AdminPricingsSelect";
import { debug } from "utils";
export default function EditorFormalitiesMeta({
  initialMeta = {},
  onSave,
  onCancel,
  title
}) {
  // ------------------------------------------------------------------
  // STATE
  // ------------------------------------------------------------------
  const [meta, setMeta] = useState({
    ftId: initialMeta.ftId ?? null,
    ftSlug: initialMeta.ftSlug ?? "",
    ftName: initialMeta.ftName ?? "",
    ftCategoryId: initialMeta.ftCategoryId ?? "",
    ftStatus: initialMeta.ftStatus ?? "inactive",
    ftSummary: initialMeta.ftSummary ?? "",
    ftLayout: initialMeta.ftLayout ?? "slides",
    ftPricingCode: initialMeta.ftPricingCode ?? "",
    ftCreatedAt: initialMeta.ftCreatedAt ?? null,
    ftCreatedBy: initialMeta.ftCreatedBy ?? null
  });
  const [errors, setErrors] = useState({});
  // ------------------------------------------------------------------
  // HELPERS
  // ------------------------------------------------------------------
  const update = (field) => (value) => {
    setMeta((prev) => ({
      ...prev,
      [field]: value
    }));
  };
  const validate = () => {
    const e = {};
    if (!meta.ftName.trim())
      e.ftName = "Le nom est obligatoire";
    if (!meta.ftCategoryId)
      e.ftCategoryId = "La catégorie est obligatoire";
    if (!meta.ftPricingCode)
      e.ftPricingCode = "Le tarif est obligatoire";
    setErrors(e);
    return Object.keys(e).length === 0;
  };
  const handleSubmit = () => {
    if (!validate()) return;
    const cleaned = {
      ...meta,
      ftSlug: meta.ftSlug.trim() || null,
      ftName: meta.ftName.trim(),
      ftSummary: meta.ftSummary.trim()
    };
    onSave(cleaned);
  };
  // ------------------------------------------------------------------
  // RENDER
  // ------------------------------------------------------------------
  return (
    <div className="p-3" style={{ maxWidth: "900px" }}>
      <h4 className="mb-4">
        {title || "Métadonnées de la formalité"}
      </h4>
      <div className="row g-4">
        {/* COL GAUCHE */}
        <div className="col-12 col-md-6 pe-md-4">
          {/* NAME */}
          <div className="mb-3">
            <label className="form-label">
              Nom *
            </label>
            <input
              type="text"
              className={`form-control ${errors.ftName ? "is-invalid" : ""}`}
              value={meta.ftName}
              onChange={(e) => update("ftName")(e.target.value)}
            />
            {errors.ftName &&
              <div className="invalid-feedback">
                {errors.ftName}
              </div>
            }
          </div>
          {/* SLUG */}
          <div className="mb-3">
            <label className="form-label">
              Slug
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="auto-généré si vide"
              value={meta.ftSlug}
              onChange={(e) => update("ftSlug")(e.target.value)}
            />
          </div>
          {/* CATEGORY */}
          <div className="mb-3">
            <label className="form-label">
              Catégorie *
            </label>
            <AdminCategoriesSelect
              value={meta.ftCategoryId}
              onChange={update("ftCategoryId")}
            />
            {errors.ftCategoryId &&
              <div className="text-danger small mt-1">
                {errors.ftCategoryId}
              </div>
            }
          </div>
          {/* PRICING */}
          <div className="mb-3">
            <label className="form-label">
              Grille tarifaire *
            </label>
            <AdminPricingsSelect
              value={meta.ftPricingCode}
              onChange={update("ftPricingCode")}
            />
            {errors.ftPricingCode &&
              <div className="text-danger small mt-1">
                {errors.ftPricingCode}
              </div>
            }
          </div>
        </div>
        {/* COL DROITE */}
        <div className="col-12 col-md-6 ps-md-4">
          {/* SUMMARY */}
          <div className="mb-3">
            <label className="form-label">
              Résumé (public)
            </label>
            <textarea
              className="form-control"
              rows="5"
              value={meta.ftSummary}
              onChange={(e) => update("ftSummary")(e.target.value)}
            />
          </div>
          {/* LAYOUT */}
          <div className="mb-3">
            <label className="form-label">
              Layout
            </label>
            <select
              className="form-select"
              value={meta.ftLayout}
              onChange={(e) => update("ftLayout")(e.target.value)}
            >
              <option value="slides">Diaporama</option>
              <option value="top">Onglets en haut</option>
              <option value="left">Onglets à gauche</option>
              <option value="right">Onglets à droite</option>
            </select>
          </div>
          {/* STATUS */}
          <div className="form-check form-switch mt-4">
            <input
              className="form-check-input"
              type="checkbox"
              checked={meta.ftStatus === "active"}
              onChange={(e) =>
                update("ftStatus")(e.target.checked ? "active" : "inactive")
              }
            />
            <label className="form-check-label ms-2">
              Actif
            </label>
          </div>
        </div>
      </div>
      {/* ACTIONS */}
      <div className="d-flex justify-content-end gap-3 mt-4">
        <button
          className="btn btn-secondary"
          onClick={onCancel}
        >
          Annuler
        </button>
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
        >
          Enregistrer
        </button>
      </div>
      {false && debug(meta)}
    </div>
  );
}